/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Vetting_DescriptionInputs */



/**
* | output |
* | --- |
* | "Mock inspections that identify and close compliance gaps before a formal vetting." |
*
* @param {Service_Pre_Vetting_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_vetting_description = /** @type {((inputs?: Service_Pre_Vetting_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Vetting_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在正式审查前开展模拟检查，发现并弥补合规差距。")
	return /** @type {LocalizedString} */ ("Mock inspections that identify and close compliance gaps before a formal vetting.")
});